import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'onpage-advisor/:url',
  async getComponent (nextState) {
    const {
      default: OnpageAdvisorContainer
    } = await import(/* webpackChunkName: "onpage-advisor" */ './components/OnpageAdvisorContainer')
      .catch(handleChunkLoadError);
    return OnpageAdvisorContainer;
  },
  getData ({ params, context }) {
    return context.props;
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: ReviewPane
        } = await import(/* webpackChunkName: "onpage-advisor" */ './components/ReviewPane')
          .catch(handleChunkLoadError);
        return ReviewPane;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'traffic',
      async getComponent (nextState) {
        const {
          default: TrafficStatsPane
        } = await import(/* webpackChunkName: "onpage-advisor" */ './components/TrafficStatsPane')
          .catch(handleChunkLoadError);
        return TrafficStatsPane;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'rum',
      async getComponent (nextState) {
        const {
          default: RumPane
        } = await import(/* webpackChunkName: "onpage-advisor" */ './components/RumPane')
          .catch(handleChunkLoadError);
        return RumPane;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'pages',
      async getComponent (nextState) {
        const {
          default: PagesPane
        } = await import(/* webpackChunkName: "onpage-advisor" */ './components/PagesPane')
          .catch(handleChunkLoadError);
        return PagesPane;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'speed',
      async getComponent (nextState) {
        const {
          default: SpeedStatsPane
        } = await import(/* webpackChunkName: "onpage-advisor" */ './components/SpeedStatsPane')
          .catch(handleChunkLoadError);
        return SpeedStatsPane;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'proxy',
      async getComponent (nextState) {
        const {
          default: GaEventProxyPane
        } = await import(/* webpackChunkName: "onpage-advisor" */ './components/GaEventProxyPane')
          .catch(handleChunkLoadError);
        return GaEventProxyPane;
      }
    }
  ]
});
